export default __webpack_public_path__ + "static/media/hewlett-packard.9b905502.svg";